export default "__VITE_ASSET__D0Rc9JVB__"